import React from 'react';
import ReportPageWithMonthWeekSwitch from './components/ReportPageWithMonthWeekSwitch';
import KeyWorkflowsModifiedByMonthByUserList from './components/month/KeyWorkflowsModifiedByMonthByUserList';
import KeyWorkflowsModifiedByWeekByUserList from './components/week/KeyWorkflowsModifiedByWeekByUserList';

function KeyWorkflowsModifiedByUser() {
  return (
    <ReportPageWithMonthWeekSwitch
      title="Key workflows modified by user"
      MonthList={KeyWorkflowsModifiedByMonthByUserList}
      WeekList={KeyWorkflowsModifiedByWeekByUserList}
    />
  );
}

export default KeyWorkflowsModifiedByUser;
